import { frontendURL } from '../../../helper/URLHelper';

const TasksBoard = () => import('./pages/TasksBoard.vue');
const TaskSettings = () => import('./pages/TaskSettings.vue');

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'tasks_board',
    component: TasksBoard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/tasks/settings'),
    name: 'tasks_settings',
    component: TaskSettings,
    meta: { permissions: ['administrator'] },
  },
];
